module.exports = __webpack_public_path__ + "img/logoDark.0e320d0b.png";